"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformQuantityOrderedToDataTable = void 0;
const transformQuantityOrderedToDataTable = order => ({
  cells: [{
    value: order.deliveryDate,
    className: 'cds-StockCountTable-Date'
  }, {
    value: order.quantityOrdered,
    className: 'cds-StockCountTable-Amount'
  }]
});
exports.transformQuantityOrderedToDataTable = transformQuantityOrderedToDataTable;
//# sourceMappingURL=dataMappers.js.map